import { useEffect, useState } from "react";
import "./Actions.css";
import { useUtilImages } from "../../Services/Hooks/useUtilImages";

const Actions = ({
  actionsNewCardClick,
}: {
  actionsNewCardClick: () => void;
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { plus } = useUtilImages();

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 1700);
  }, []);

  return (
    <div className="Actions">
      <img
        src={plus}
        alt="add new card"
        onClick={actionsNewCardClick}
        className={`Actions-icons ${
          !isLoaded
            ? "animate__animated animate__fadeInUpBig animate__delay-1s"
            : ""
        } `}
      ></img>
    </div>
  );
};

export default Actions;
